import {
  Directive,
  ElementRef,
  OnInit,
  AfterViewInit,
  OnDestroy
} from '@angular/core';

import {
  LayoutService
} from "@app/core/services/layout.service";
import {
  Router
} from "@angular/router";
import {
  Subscription
} from 'rxjs';

@Directive({
  selector: '[saSmartMenu]'
})
export class SmartMenuDirective implements OnInit, AfterViewInit, OnDestroy {

  private $menu: any;
  private layoutSub: Subscription;
  private lastMenuSignature: string | null = null;

  constructor(
    private menu: ElementRef,
    private router: Router,
    public layoutService: LayoutService
  ) {
    this.$menu = $(this.menu.nativeElement);
  }

  ngOnInit() {
    this.layoutSub = this.layoutService.subscribe((store) => {
      this.processLayout(store)
    });

    // collapse menu on mobiles
    $('[routerLink]', this.$menu).on('click', () => {
      if (this.layoutService.store.mobileViewActivated) {
        this.layoutService.onCollapseMenu()
      }
    })

  }

  ngAfterViewInit() {
    this.$menu.find('li:has(> ul)').each((i, li) => {
      let $menuItem = $(li);
      let $a = $menuItem.find('>a');
      let sign = $('<b class="collapse-sign"><em class=""/></b>');

      $a.on('click', (e) => {
        this.toggle($menuItem);
        e.stopPropagation();
        return false;
      }).append(sign);
    })

    setTimeout(()=>{
      this.processLayout(this.layoutService.store, true)
    }, 200)

  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  private processLayout = (layoutStore, force: boolean = false) => {
    const signature = [
      !!layoutStore.menuOnTop,
      !!layoutStore.mobileViewActivated,
      this.$menu.find('li.active').length,
      this.$menu.find('li.open').length
    ].join('|');

    // Skip repeated animated menu reconciliation when nothing meaningful changed.
    if (!force && signature === this.lastMenuSignature) {
      if (layoutStore.mobileViewActivated) {
        $('body').removeClass("minified");
      }
      return;
    }
    this.lastMenuSignature = signature;

    if (layoutStore.menuOnTop) {
      this.$menu.find('li.open').each((i, li) => {
        this.toggle($(li), false, true)
      })
    } else {
      this.$menu.find('li.active').each((i, li) => {
        $(li).parents('li').each((j, parentLi) => {
          this.toggle($(parentLi), true, true)
        })
      })
    }

    if (layoutStore.mobileViewActivated) {
      $('body').removeClass("minified");
    }
  };

  private toggle($el, condition = !$el.data('open'), instant = false) {
    const currentlyOpen = !!$el.data('open');
    if (currentlyOpen === !!condition) {
      return;
    }

    $el.toggleClass('open', condition);

    const $submenu = $el.find('>ul');
    if (instant || this.layoutService.store.mobileViewActivated) {
      // Avoid jQuery animation churn on mobile/resize-driven layout sync.
      if (condition) {
        $submenu.show();
      } else {
        $submenu.hide();
      }
    } else if (condition) {
      $submenu.slideDown();
    } else {
      $submenu.slideUp();
    }

    $el.find('>a>.collapse-sign>em')
      .toggleClass('', !condition)
      .toggleClass('', condition);

    $el.data('open', condition);

    if (condition) {
      $el.siblings('.open').each((i, it) => {
        let sib = $(it);
        this.toggle(sib, false, instant)
      })
    }
  }

}
